import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import gameData from '../gameData';
import Keyboard from './Keyboard';
import SoundAssetKeys from '../SoundAssetKeys';
import FontKeys from '../FontKeys';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  create() {
    console.log('starting Game');

    gameData.currentScene = 'Game';
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.level = 1;

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    const keys = gameData.maxKeys(gameData.gameMode);

    this.bg = ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, `${gameData.gameStyle}_BG`, this);

    this.keyboard = new Keyboard(this, this.mid.x, 585);

    if (gameData.gameMode === 'letters') {
      this.keyboard.lockSymbols();
      this.keyboard.unhideSymbols(true);
    }

    this.time.delayedCall(1000, () => {this.keyboard.shuffleKeys();});

    this.createOldNavBar();

    this.createInstructions();
  }

  createInstructions() {
    this.inst = ABCyaPhaser.Images.addImage(this.keyboard.x, this.keyboard.y, `${gameData.gameStyle}_Instr`, this);
    this.inst.setScale(0, 0);

    ABCyaPhaser.Tweens.addTween(
      this.inst,
      500,
      { scaleX: 1, scaleY: 1 },
      Phaser.Math.Easing.Back.Out,
      () => {this.time.delayedCall(2500, () => {this.hideInstructions();});}
    );
  }

  hideInstructions() {
    ABCyaPhaser.Tweens.addTween(
      this.inst,
      500,
      { scaleX: 0, scaleY: 0 },
      Phaser.Math.Easing.Back.In,
      () => {this.inst.destroy();}
    );
  }

  createOldNavBar() {
    this.oldBG = ABCyaPhaser.Images.addImage(this.mid.x, 30, 'welcomeKeys', this);
    this.tile1 = ABCyaPhaser.Images.addImage(360, 81, 'Key_Y', this);
    this.tile2 = ABCyaPhaser.Images.addImage(937, 194, 'Key_E', this);

    ABCyaPhaser.Tweens.addTween(this.oldBG, 1000, { y: -250 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.tile1, 1000, { y: -200 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(
      this.tile2,
      1000,
      { y: -80 },
      Phaser.Math.Easing.Linear,
      () => {this.createNavBar();}
    );
  }

  createNavBar() {
    if (this.oldBG) {
      this.oldBG.destroy();
      this.tile1.destroy();
      this.tile2.destroy();
    }

    this.home = ABCyaPhaser.Buttons.addSimpleButton(55, -75, 'Btn_Home', null, () => {
      this.cleanUp();
    }, this, { disabledTint: '0xFFFFFF' });
    this.startOver = ABCyaPhaser.Buttons.addSimpleButton(this.home.x + this.home.width, -75, 'Btn_StartOver', null, () => {
      this.resetBoard();
    }, this, { disabledTint: '0xFFFFFF' });
    this.save = ABCyaPhaser.Buttons.addSimpleButton(this.startOver.x + this.startOver.width, -75, 'Btn_Save', null, () => {
      this.screenshot();
    }, this, { disabledTint: '0xFFFFFF' });
    this.triesBG = ABCyaPhaser.Images.addImage(940, -75, 'Btn_Tries', this);
    this.tries = ABCyaPhaser.Text.addText(this.triesBG.x + 38, this.triesBG.y - this.triesBG.height / 2, 24, '0xFFFFFF', FontKeys._bpreplayregular, '0', this, true);

    if (gameData.hideNav === true) {
      this.startOver.alpha = 0;
      this.save.alpha = 0;
    }

    this.disableBtns();
  }

  showNav() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    if (gameData.hideNav === false) {
      this.startOver.alpha = 1;
      this.save.alpha = 1;

      ABCyaPhaser.Tweens.addTween(this.startOver, 500, { y: 0, delay: 200 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(this.save, 500, { y: 0, delay: 400 }, Phaser.Math.Easing.Quadratic.Out);
    }

    ABCyaPhaser.Tweens.addTween(
      this.home,
      500,
      { y: 0 },
      Phaser.Math.Easing.Quadratic.Out,
      () => {this.enableBtns();}
    );
    ABCyaPhaser.Tweens.addTween(this.triesBG, 500, { y: 0, delay: 600 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.tries, 500, { y: 25, delay: 600 }, Phaser.Math.Easing.Quadratic.Out);
  }

  showEndNav() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    if (gameData.hideNav === false) {
      this.startOver.alpha = 1;
      this.save.alpha = 1;
    }

    ABCyaPhaser.Tweens.addTween(
      this.startOver,
      500,
      { y: 0, delay: 200 },
      Phaser.Math.Easing.Quadratic.Out,
      () => {this.enableBtns();}
    );

    ABCyaPhaser.Tweens.addTween(this.save, 500, { y: 0, delay: 400 }, Phaser.Math.Easing.Quadratic.Out);
  }

  hideNav() {
    this.disableBtns();

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    ABCyaPhaser.Tweens.addTween(this.home, 250, { y: -75 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.startOver, 250, { y: -75 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.save, 250, { y: -75 }, Phaser.Math.Easing.Quadratic.Out);
  }

  screenshot() {
    // console.log("taking SS", this.size);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._flash_camera, this);

    const rect = new Phaser.Geom.Rectangle(0, 0, this.mid.x * 2, this.mid.y * 2);
    this.shader = this.add.graphics({ fillStyle: { color: 0xFFFFFF } });
    this.shader.fillRectShape(rect);

    if (gameData.gameStyle === 'Wood' || gameData.gameStyle === 'Classic' || gameData.gameStyle === 'SciFi') {
      this.logo = ABCyaPhaser.Images.addImage(this.mid.x, 50, 'logoWhite', this);
    }
    else {
      this.logo = ABCyaPhaser.Images.addImage(this.mid.x, 50, 'logoBlack', this);
    }

    this.hideNav();

    this.logo.setAlpha(0);
    ABCyaPhaser.Tweens.addTween(this.shader, 250, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(
      this.logo,
      250,
      { alpha: 1 },
      Phaser.Math.Easing.Linear,
      () => {
        console.log('TAKING A SCREENSHOT');
        this.renderer.snapshot(async (image) => {
          const printResult = await ABCyaLib.PrintSave.instance.printImage(image);
        });
      }
    );

    this.time.delayedCall(1000, () => {this.reshowGame();});
  }

  reshowGame() {
    ABCyaPhaser.Tweens.addTween(
      this.logo,
      250,
      { alpha: 0 },
      Phaser.Math.Easing.Linear,
      () => {this.logo.destroy();}
    );

    this.showNav();
  }

  createEnding() {
    gameData.hideNav = false;
    this.showEndNav();

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._good_job, this);

    let txt;
    if (gameData.gameMode === 'all') {
      txt = gameData.tries === 1 ? `You fixed the keyboard in ${gameData.tries} try!\nBest score: ${gameData.bestAll}/60 tries.` : `You fixed the keyboard in ${gameData.tries} tries!\nBest score: ${gameData.bestAll}/60 tries.`;
    }
    else {
      txt = gameData.tries === 1 ? `You fixed the keyboard in ${gameData.tries} try!\nBest score: ${gameData.bestLetters}/36 tries.` : `You fixed the keyboard in ${gameData.tries} tries!\nBest score: ${gameData.bestLetters}/36 tries.`;
    }

    let tint;
    if (gameData.gameStyle === 'Wood') {
      tint = '0x5a3318';
    }
    else if (gameData.gameStyle === 'SciFi') {
      tint = '0x161a47';
    }
    else if (gameData.gameStyle === 'Slime') {
      tint = '0x558e24';
    }
    else if (gameData.gameStyle === 'Lava') {
      tint = '0x772828';
    }
    else if (gameData.gameStyle === 'Rnbow') {
      tint = '0x4f059e';
    }
    else if (gameData.gameStyle === 'Classic') {
      tint = '0x231f20';
    }
    this.greatJob = ABCyaPhaser.Images.addImage(this.mid.x, -90, `${gameData.gameStyle}_GrtJob`, this);
    this.endBG = ABCyaPhaser.Images.addImage(this.mid.x, 325, 'congratsBG', this);
    this.endTxt = ABCyaPhaser.Text.addText(this.endBG.x, this.endBG.y, 24, tint, FontKeys._bpreplayregular, txt, this, true);

    this.endBG.setScale(0, 0);
    this.endTxt.setScale(0, 0);

    ABCyaPhaser.Tweens.addTween(this.greatJob, 2000, { y: 160 }, Phaser.Math.Easing.Bounce.Out);
    ABCyaPhaser.Tweens.addTween(this.endBG, 1000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.endTxt, 1000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  }

  hideEnding() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    ABCyaPhaser.Tweens.addTween(
      this.greatJob,
      750,
      { y: -90 },
      Phaser.Math.Easing.Back.In,
      () => {this.greatJob.destroy();}
    );
    ABCyaPhaser.Tweens.addTween(
      this.endBG,
      750,
      { scaleX: 0, scaleY: 0 },
      Phaser.Math.Easing.Back.In,
      () => {this.endBG.destroy();}
    );
    ABCyaPhaser.Tweens.addTween(
      this.endTxt,
      750,
      { scaleX: 0, scaleY: 0 },
      Phaser.Math.Easing.Back.In,
      () => {this.endTxt.destroy();}
    );
  }

  updateTries(isCorrect) {
    gameData.tries++;

    this.tries.text = gameData.tries;

    if (isCorrect) {
      gameData.placementCounter++;

      if (gameData.placementCounter === gameData.maxKeys(gameData.gameMode)) {
        if (gameData.gameMode === 'all') {
          if (gameData.bestAll === 0) {
            gameData.bestAll = gameData.tries;
          }
          else if (gameData.tries < gameData.bestAll) {
            gameData.bestAll = gameData.tries;
          }
        }
        else {
          if (gameData.bestLetters === 0) {
            gameData.bestLetters = gameData.tries;
          }
          else if (gameData.tries < gameData.bestLetters) {
            gameData.bestLetters = gameData.tries;
          }
        }

        this.createEnding();
      }
    }
  }

  resetBoard() {
    gameData.tries = 0;
    gameData.placementCounter = 0;
    gameData.hideNav = true;

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    this.startOver.setEnabled(false);
    this.save.setEnabled(false);
    ABCyaPhaser.Tweens.addTween(this.startOver, 500, { y: -75 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.save, 500, { y: -75 }, Phaser.Math.Easing.Quadratic.Out);

    this.keyboard.startOver();
    this.hideEnding();
  }

  enableBtns() {
    this.home.setEnabled(true);

    if (gameData.hideNav === false) {
      this.startOver.setEnabled(true);
      this.save.setEnabled(true);
    }
  }

  disableBtns() {
    this.home.setEnabled(false);
    this.startOver.setEnabled(false);
    this.save.setEnabled(false);
  }

  cleanUp() {
    console.log('going to level 1');
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    this.tweens.killAll();

    this.disableBtns();

    this.keyboard.cleanUp();
    this.keyboard.destroy();

    this.bg.destroy();
    this.home.destroy();
    this.startOver.destroy();
    this.save.destroy();
    this.triesBG.destroy();
    this.tries.destroy();

    this.scene.start('Intro');
  }
}